import React, { Component } from 'react';
import { useTable,useSortBy, useFilters, useGlobalFilter, useAsyncDebounce, usePagination } from 'react-table'
import styled from 'styled-components'
import {matchSorter} from 'match-sorter'

const Styles = styled.div`
  padding: 1rem;
  table {
    border-spacing: 0;
    border: 1px solid black;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;
      :last-child {
        border-right: 0;
      }
    }
  }
`

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length
  
    return (
      <input
        value={filterValue || ''}
        onChange={e => {
          setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    )
  }

  function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
  }) {
    const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
    }, 200)
  
    return (
      <span>
        Search:{' '}
        <input
          value={value || ""}
          onChange={e => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          placeholder={`${count} records...`}
          style={{
            fontSize: '1.1rem',
            border: '0',
          }}
        />
      </span>
    )
  }

class ReactTableExample extends Component{

    // Let the table remove the filter if the string is empty
    //fuzzyTextFilterFn.autoRemove = val => !val

    
    
    render(){
        function Table({ columns, data }) {
           

            const filterTypes = React.useMemo(
                () => ({
                  // Add a new fuzzyTextFilterFn filter type.
                  fuzzyText: fuzzyTextFilterFn,
                  // Or, override the default text filter to use
                  // "startWith"
                  text: (rows, id, filterValue) => {
                    return rows.filter(row => {
                      const rowValue = row.values[id]
                      return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .startsWith(String(filterValue).toLowerCase())
                        : true
                    })
                  },
                }),
                []
              )
            
              const defaultColumn = React.useMemo(
                () => ({
                  // Let's set up our default Filter UI
                  Filter: DefaultColumnFilter,
                }),
                []
              )
            // Use the state and functions returned from useTable to build your UI
            const {
                getTableProps,
                getTableBodyProps,
                headerGroups,
                prepareRow,
                page,
                visibleColumns,
                preGlobalFilteredRows,
                setGlobalFilter,
                canPreviousPage,
                canNextPage,
                pageOptions,
                pageCount,
                gotoPage,
                nextPage,
                previousPage,
                setPageSize,
                state: { pageIndex, pageSize },
            } = useTable({
                columns,
                data,
                initialState: { pageIndex: 0 },
                defaultColumn, // Be sure to pass the defaultColumn option
                filterTypes,
            },
            useFilters, // useFilters!
            useGlobalFilter,
            useSortBy,
            usePagination
        )
          
            // Render the UI for your table

            //const firstPageRows = rows
            return (
                <>
                <table {...getTableProps()}>
                  <thead>
                    {headerGroups.map((headerGroup,i) => (
                      <tr className={i==1?"tr-a":""} {...headerGroup.getHeaderGroupProps()}>
                       
                        {headerGroup.headers.map(column => (
                          // Add the sorting props to control sorting. For this example
                          // we can add them into the header props
                          <th  className={i==0?"td-h":""} {...column.getHeaderProps(column.getSortByToggleProps())}>
                           <div>{column.render('Header')}</div> 
                            {/* Add a sort direction indicator */}
                            <div>{column.canFilter ? column.render("Filter") : null}</div>
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? ' 🔽'
                                  : ' 🔼'
                                : ''}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                    {/* <tr>
                    <th
                        colSpan={visibleColumns.length}
                        style={{
                            textAlign: 'left',
                        }}
                        > */}
                        {/* <GlobalFilter
                            preGlobalFilteredRows={preGlobalFilteredRows}
                            globalFilter={state.globalFilter}
                            setGlobalFilter={setGlobalFilter}
                        /> */}
                        {/* </th>
                    </tr> */}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map(
                      (row, i) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                              return (
                                <td className="td-d2 p-7"{...cell.getCellProps()}>{cell.render('Cell')}</td>
                              )
                            })}
                          </tr>
                        )}
                    )}
                  </tbody>
                </table>
                <br />
                <div className="pagination">
        <button  class="page-item" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button class="page-item" onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button class="page-item" onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button class="page-item" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span class="mt-1 ml-2">
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span class="ml-1">
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
              </>
            )
          }
          var propsValues = this.props
          
        // const columns = [
        //     {
        //         Header : ' ',
        //         columns: [
        //             {
        //               Header: 'Product Name',
        //               accessor: 'Product Name',
        //               filter: "fuzzyText"
        //             }
        //           ]
        //     },
        //     {
        //       Header: 'Blank Imprint',
        //       columns: [
        //         {
        //           Header: 'Prediction',
        //           accessor: 'Blank_Imprint_Prediction',
        //         },
        //         {
        //           Header: 'Confidence %',
        //           accessor: 'Blank_Imprint_Confidence',
        //         }
        //       ]
        //     },
        //     {
        //     Header: 'Shot View',
        //     columns: [
        //         {
        //         Header: 'Prediction',
        //         accessor: 'Shot_Prediction',
        //         },
        //         {
        //         Header: 'Confidence %',
        //         accessor: 'Shot_Confidence',
        //         }
        //     ]
        //     },
        //     {
        //     Header: 'Single Multi',
        //     columns: [
        //         {
        //         Header: 'Prediction',
        //         accessor: 'Multi_Single_Prediction',
        //         },
        //         {
        //         Header: 'Confidence %',
        //         accessor: 'Multi_Single_Confidence',
        //         }
        //     ]
        //     },
        //     {
        //     Header: 'Color Categorization',
        //     columns: [
        //         {
        //         Header: 'Color Name',
        //         accessor: 'PCNA_colour_Prediction',
        //         },
        //         {
        //         Header: 'RGB Values',
        //         accessor: 'RGB_value_Confidence',
        //         }
        //     ]
        //     }
        // ]

        
        const data = this.props.data!==undefined ? this.props.data: ""
        const columns = this.props.columns
        return(
               
            <Styles>
            <Table columns={columns} data={data} />
          </Styles>
            
        )
    }
}

export default ReactTableExample;